import { createFileRoute } from '@tanstack/react-router'
import { ProjectsTimelinePage } from '@/pages/projects-timeline'

export const Route = createFileRoute('/_authenticated/projects/timeline')({
  staticData: { title: 'Timeline' },
  component: ProjectsTimelinePage,
})
